import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { getDracoWorkerLimit, isLightweightViewer } from '../../viewport/readCapabilities'

// v1/decoders/ no tiene versión: el 15 oct 2026 Google publicó un build que ya no
// exporta HEAPF32. DRACOLoader (three 0.160) hace draco.HEAPF32.buffer en decodeAttribute
// y esos GLB fallan con "reading 'buffer'". 1.5.6 es la que este three espera.
const DRACO_DECODER_PATH = 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/'

let sharedLoader: GLTFLoader | null = null
let sharedDraco: DRACOLoader | null = null

/**
 * One GLTFLoader + one Draco worker pool for the whole app.
 * Phone: JS decoder — Safari kills WASM workers when the tab is backgrounded.
 * Tablet/desktop: WASM workers, limit 2.
 */
export function setGLTFLoader() {
  if (sharedLoader) return sharedLoader

  const dracoLoader = new DRACOLoader()
  dracoLoader.setDecoderPath(DRACO_DECODER_PATH)
  if (isLightweightViewer()) {
    dracoLoader.setDecoderConfig({ type: 'js' })
  }
  dracoLoader.setWorkerLimit(getDracoWorkerLimit())
  sharedDraco = dracoLoader

  const loader = new GLTFLoader()
  loader.setDRACOLoader(dracoLoader)
  sharedLoader = loader
  return loader
}

/** Recreate the shared decoder after workers die (background / context restore). */
export function resetSharedGLTFLoader() {
  if (!sharedLoader && !sharedDraco) return
  try {
    sharedDraco?.dispose()
  } catch {
    // worker already dead
  }
  sharedDraco = null
  sharedLoader = null
}
